import React, { useMemo } from "react";
import stylesCommon from "@/styles/detail/DetailBookingSidebar/DetailBookingConfigurator.module.scss";
import { InfoType } from "@/models/common/enums";
import { ExclusionDaysResponseTo, SlotsReadableTO } from "@/models/detail";
import moment from "moment";
import RangeDatePicker from "../../addToCart/datepicker/RangeDatePicker";

const DatePickerSectionDetail = ({
    toggleInfoModal,
    days,
    isPremium,
    daysExcluded,
    discountedDates,
    startDate,
    slots,
    setStartDate,
    setStartDateView,
    click,
    setClick,
    startDateView,
}: {
    toggleInfoModal: (info: InfoType) => void;
    days: number;
    isPremium: boolean;
    daysExcluded: ExclusionDaysResponseTo | undefined;
    discountedDates: string[];
    startDate: Date | null;
    startDateView: Date | null;
    slots: SlotsReadableTO[];
    setStartDate: React.Dispatch<React.SetStateAction<Date>>;
    setStartDateView: React.Dispatch<React.SetStateAction<Date | null>>;
    click: boolean;
    setClick: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
    const selectedExclusions = useMemo(
        () =>
            (isPremium
                ? daysExcluded?.toExcludePremium
                : daysExcluded?.toExcludeQuality) ?? [],
        [daysExcluded, isPremium]
    );

    const slotsLastDate = useMemo(
        () => moment.max(slots.map(slot => moment(slot.endDate))).toDate(),
        [slots]
    );

    // useEffect(() => {
    //     const selectedDateParam = router.query;

    //     if (selectedDateParam.selectedDate === undefined) {
    //         setStartDate(
    //             getFirstUsefulDate(
    //                 isPremium
    //                     ? daysExcluded?.toExcludePremium
    //                     : daysExcluded?.toExcludeQuality
    //             )
    //         );
    //     }
    // }, []);

    return (
        <>
            <div className="d-flex justify-content-between align-items-center">
                <h3 className={stylesCommon.configuratorTitle}>Arrival date</h3>
            </div>
            <p className={stylesCommon.configuratorDescription}>
                By selecting your arrival day, the departure date will be
                automatically set according to the durantion of your vacation.
                If the system doesn&apos;t let you pick a date, that means that
                our journeys are not available from that day.
            </p>
            <RangeDatePicker
                excludeDates={selectedExclusions}
                discountedDates={discountedDates}
                rangeLength={+days}
                selectedDate={startDate}
                lastDate={slotsLastDate}
                setSelectedDate={setStartDate}
                click={click}
                startDateView={startDateView}
                setStartDateView={setStartDateView}
                setClick={setClick}
            />
            <p
                className={`${stylesCommon.configuratorDescription} text-center mb-0`}
            >
                Do you wish to spend some extra time in Italy?
            </p>
            <div className="d-flex justify-content-center align-items-center">
                <span
                    className={`${stylesCommon.configuratorDescription} text-center text-decoration-underline mt-0`}
                    onClick={() => toggleInfoModal(InfoType.EXTRA_NIGHTS)}
                >
                    Here&apos;s how to do it
                </span>
            </div>
        </>
    );
};

export default DatePickerSectionDetail;
